export default __webpack_public_path__ + "static/media/IDIA.4286f99f.svg";